import { BackendModel, BackendService } from '../core/backend.service';

export class Provincia extends BackendModel {

  static path = '/parametricas/';

  id: number;
  nombre: string;
  codigoAfip: string;

  constructor(protected backendService: BackendService, model?: Provincia) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/provincia.model.ts